import { Fragment, useEffect, useState } from "react";
import Menu from "../../../../modules/public/menu/menu";
import FooterPostup from "../../../../modules/public/footer/footer";
import PaySection from "./components/PaySection";
import PartsDetails from "./components/PartsDetails";
import FactorContext from "./context/FactorContext";
import { getRequestByAuth } from "../../../../function/helper";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../../../modules/public/loading/loading";
import Swal from "sweetalert2";

function PreFactor() {
  const [loading, setLoading] = useState(true);
  const params = useParams();
  const navigate = useNavigate();

  const [factorDetail, setFactorDetail] = useState({
    companyId: 0,
    shipments: [],
    discountCode: 0,
    wallet: 0,
  });

  const getData = async () => {
    setLoading(true);
    const response = await getRequestByAuth(
      `/totalpost/v1/preview/${params.id}`
    );
    setLoading(false);

    if (response && response.status === 200) {
      setFactorDetail(cur => ({
        ...cur,
        shipments: response.data,
        wallet: response.wallet,
        companyId: response.data[0]?.item?.componyId,
      }));

      isAllSameMethod(response.data);
    } else if (response && response.errorCode === 1) {
      Swal.fire({
        icon: "warning",
        title: "نیاز به ورود مجدد",
        confirmButtonText: "باشه",
      }).then(() => {
        window.location.href = "/login";
      });
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const isAllSameMethod = array => {
    const isCod = array[0]?.item?.isCod;

    array.forEach(({ item }) => {
      if (item.isCod !== isCod) {
        Swal.fire({
          icon: "error",
          text: "مرسولات نمی‌توانند از نوع پراخت های مختلف باشند",
          confirmButtonText: "متوجه شدم",
          confirmButtonColor: "gray",
        }).then(() => {
          navigate("/");
        });
      }
    });
  };

  if (loading) return <Loading />;

  return (
    <Fragment>
      <Menu />
      <main className="container py-4 flex-grow-1 rtl-all">
        <FactorContext.Provider value={{ factorDetail, setFactorDetail }}>
          <PartsDetails />
          <PaySection />
        </FactorContext.Provider>
      </main>
      <FooterPostup />
    </Fragment>
  );
}

export default PreFactor;
